import { ref } from 'vue';
import { getActionCardsInlineTextApi } from '@/api/encounterNotes';
import { CARD_TYPES } from '../utils/actionCardUtils';

// Module-level cache — shared across all components that import this composable
const inlineTextMap = ref({});
const isLoaded = ref(false);
const isLoading = ref(false);

const TYPES = [
  CARD_TYPES.APPOINTMENT,
  CARD_TYPES.TASK,
  CARD_TYPES.ORDER,
  CARD_TYPES.DOCUMENT,
];

/**
 * Fetch inline text for all action card types.
 * Only fetches once; subsequent calls return cached data.
 */
const fetchAllInlineText = async () => {
  if (isLoaded.value || isLoading.value) return;

  isLoading.value = true;
  try {
    const results = await Promise.all(
      TYPES.map(async (type) => {
        try {
          const data = await getActionCardsInlineTextApi(type);
          return { type, data };
        } catch (error) {
          console.error(`Failed to fetch inline text for ${type}:`, error);
          return { type, data: null };
        }
      })
    );

    const map = {};
    for (const { type, data } of results) {
      if (data) {
        map[type] = data;
      }
    }
    inlineTextMap.value = map;
    isLoaded.value = true;
  } finally {
    isLoading.value = false;
  }
};

export const useActionCardsInlineText = () => {
  return {
    inlineTextMap,
    isLoaded,
    isLoading,
    fetchAllInlineText,
  };
};
